import { render } from "./CreateReferralHomeCare.vue?vue&type=template&id=342a2d46&ts=true"
import script from "./CreateReferralHomeCare.ts?vue&type=script&lang=ts&external"
export * from "./CreateReferralHomeCare.ts?vue&type=script&lang=ts&external"

import "./CreateReferralHomeCare.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__